import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Table, Tabs } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useQuestionStore } from '../QuestionProvider';
import css from './index.module.scss';
import { EFArrow } from '@/components/UI/svg/Search';
import { NoDataIcon } from '@/components/UI/svg/Ecocredits';
import { getAwardLog, getAnswerLog } from '@/service/vip';
import { useGlobal } from '@/utils/useGlobal';
import { IAnswerRow, IAwardRow } from '@/components/AppreciationDay/index.d';
import { message } from '@/components/UI';
interface props {
    show: boolean;
    openModal?: () => void;
    modal?: boolean;
}

const PointsActivity: React.FC<props> = ({ show, openModal, modal }) => {
    const { useLang, useRouter, isMobile } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('appreciationday');
    const [awardLog, setAwardLog] = useState<IAwardRow[]>([]);
    const [answerLog, setAnswerLog] = useState<IAnswerRow[]>([]);
    const { questionInfo } = useQuestionStore();

    const statusText: { [key: string]: string } = {
        state: t('pending'),
        REWARDED: t('question.received'),
    };

    const actionText: { [key: string]: string } = {
        QUESTION_REWARD: t('question.correctly'),
    };

    useEffect(() => {
        // 没有活动信息
        if (!questionInfo) return;
        const { campaignId } = questionInfo;
        if (show) {
            getAwardLog({ size: -1, campaignId }, locale).then((res) => {
                if (res.code !== '0') return message.error(res.message);
                setAwardLog(res.data.content);
            });
            getAnswerLog({ size: -1, campaignId }, locale).then((res) => {
                if (res.code !== '0') return message.error(res.message);
                setAnswerLog(res.data.content);
            });
        }
    }, [show]);

    const answerColumns: ColumnsType<IAnswerRow> = [
        {
            title: t('question.answer_date'),
            dataIndex: 'createTime',
            width: 150,
            render: (value) => moment(Number(value)).format('YYYY-MM-DD HH:mm:ss'),
        },
        { title: t('question.answer_title'), dataIndex: 'questionName', width: 227 },
        {
            title: t('question.answer_result'),
            dataIndex: 'correct',
            width: 141,
            className: 'color',
            render: (value) => (value ? t('question.correct') : t('question.error')),
        },
    ];

    const awardColumns: ColumnsType<IAwardRow> = [
        {
            title: t('question.award_date'),
            dataIndex: 'createTime',
            width: 200,
            render: (value) => moment(Number(value)).format('YYYY-MM-DD HH:mm:ss'),
        },
        {
            title: t('question.award_action'),
            dataIndex: 'action',
            width: 150,
            render: (val) => actionText[val] || val,
        },
        { title: t('question.ecoCredits'), dataIndex: 'points', width: 141, className: 'color' },
        {
            title: t('question.award_status'),
            dataIndex: 'status',
            width: 150,
            className: 'color',
            render: (val) => statusText[val] || val,
        },
    ];

    const Footer = () => (
        <div className="tabel-footer">
            <span onClick={openModal}>
                <span className="more-text">{t('view_more')}</span>
                <EFArrow />
            </span>
        </div>
    );

    const NoData = () => (
        <div className="no-content">
            <div className="no-content-icon">
                <NoDataIcon />
            </div>
            <p className="no-content-note">{t('no_history_note')}</p>
        </div>
    );

    return (
        <div className={`${css.points_activity} ${modal ? 'modal' : ''}`}>
            <h1 className="history-title" id="FOR-POINTS-ACTIVELY">
                {t('question.history_title')}
            </h1>

            <Tabs className="rewards-tabs" centered={isMobile}>
                <Tabs.TabPane tab={t('question.award_record')} key="points">
                    {!!awardLog?.length ? (
                        <>
                            <Table
                                columns={awardColumns}
                                dataSource={modal ? awardLog : awardLog?.slice(0, 5)}
                                rowKey="recordId"
                                className="history-tabel"
                                rowClassName={(row, i) => `${i % 2 === 1 ? 'odd' : 'even'} ${row.prizeType}`}
                                pagination={false}
                                bordered={false}
                                footer={modal ? undefined : () => <Footer />}
                            />
                            <p className="history-note">{t('history_note')}</p>
                        </>
                    ) : (
                        <NoData />
                    )}
                </Tabs.TabPane>
                <Tabs.TabPane tab={t('question.answer_record')} key="rewards">
                    {!!answerLog?.length ? (
                        <>
                            <Table
                                columns={answerColumns}
                                dataSource={modal ? answerLog : answerLog?.slice(0, 5)}
                                rowKey="id"
                                className="history-tabel"
                                rowClassName={(_row, i) => `${i % 2 === 1 ? 'odd' : 'even'}`}
                                pagination={false}
                                bordered={false}
                                footer={modal ? undefined : () => <Footer />}
                            />
                            <p className="history-note">{t('history_note')}</p>
                        </>
                    ) : (
                        <NoData />
                    )}
                </Tabs.TabPane>
            </Tabs>
        </div>
    );
};

export default PointsActivity;
